import React, { Component } from 'react';
import {Alert, Container} from 'library';
import {PaymentStatus} from 'pages';
import ReferralModal from 'components/referral_modal';
import { ajax_wrapper, get_global_state } from 'functions';

export default class ThankYouForFiling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showReferralModal: false,
            currentUser: null,
            savings: null,
            fallbackReferralLink: null,
        };
    }

    componentDidMount() {
        console.log("ThankYouForFiling componentDidMount");
        
        // Attempt to get savings from global state
        try {
            const params = get_global_state()['params'];
            if (params && params['savings']) {
                this.setState({ savings: parseFloat(params['savings']) });
            }
        } catch (error) {
            console.error("Could not get savings from global state:", error);
        }

        // Set a fallback referral link using the hostname
        const fallbackReferralLink = `${window.location.protocol}//${window.location.host}/`;
        this.setState({ fallbackReferralLink });

        // Get user data from global state instead of API call
        const globalUser = window.secret_react_state && window.secret_react_state.user;
        if (globalUser && globalUser.id) {
            console.log("Using user from global state:", globalUser);
            this.setState({ 
                currentUser: globalUser,
                showReferralModal: false // Don't show modal immediately
            });
        } else {
            console.log("No user found in global state");
            this.setState({ currentUser: null });
        }
        
        // Check URL parameters for successful payment
        const urlParams = new URLSearchParams(window.location.search);
        const paymentIntent = urlParams.get('payment_intent');
        const redirectStatus = urlParams.get('redirect_status');
        
        console.log("Payment Intent:", paymentIntent);
        console.log("Redirect Status:", redirectStatus);
        
        // Show modal if payment was successful
        if (paymentIntent && redirectStatus === 'succeeded') {
            // Set a timeout to show modal after component state updates
            setTimeout(() => {
                this.setState({ showReferralModal: true });
            }, 1000); // Wait 1 second
        }
    }

    handleCloseReferralModal = () => {
        this.setState({ showReferralModal: false });
    }

    render() {
        const { currentUser, showReferralModal, savings, fallbackReferralLink } = this.state;
        
        console.log("Render state:", {
            currentUser,
            showReferralModal,
            savings
        });
        
        // Construct referral message if savings data is available and > 0
        let referralMessage = '';
        if (savings && savings > 0) {
           referralMessage = `I just saved $${savings.toFixed(0)} on my property taxes using HomeBase! Check if you can save too.`
        }

        return(
            <Container>
            <div style={{ textAlign: 'center', minHeight:'800px' }}>
                <Alert type='success'><PaymentStatus /></Alert>
                <h1
                    style={{ fontSize: '48px', fontWeight: 'bold' }}
                    className="gradient-color"
                >
                    Thanks for choosing HomeBase.
                </h1>
                <h5>
                    We'll be in touch over email with the next steps
                    to help you save on your property taxes.
                </h5>
            </div>

            <ReferralModal
                show={showReferralModal}
                handleClose={this.handleCloseReferralModal}
                headline="Know someone who might also be overpaying?"
                referrerId={currentUser ? currentUser.id : null}
                referralMessage={referralMessage}
                fallbackLink={fallbackReferralLink}
            />
            </Container>
        );
    }
}